import React from 'react';
import {BooleanInput, Edit, SimpleForm, TextInput} from 'react-admin';

function DietTypeCategoryEdit(props) {
    return (
        <Edit {...props}>
            <SimpleForm
                redirect="show"
            >
                <TextInput source="name"/>
                <BooleanInput source="completed"/>
                <BooleanInput source="deleted"/>
            </SimpleForm>
        </Edit>
    );
}

export default DietTypeCategoryEdit;